import { Flex, Typography } from '@aloft/toolkit-sui';

import SamWave from '../../../../assets/sam/wave.png';
import { useBreakpoints } from '../../../../hooks/useBreakpoints.ts';
import { UnsubscribedViewLayout } from '../../../../layout/UnsubscribedViewLayout.tsx';
import { Form } from './Form.tsx';
import { OnboardingFormStepProps } from './types.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { selectAccount } from '../../../../redux/features/selectors/accountSelectors.ts';

export const OnboardingFormStep = ({
  referralCode,
  mcKissockOffer,
  onFinish,
}: OnboardingFormStepProps) => {
  const { isTabletAndBelow } = useBreakpoints();
  const account = useAppSelector((state) => selectAccount(state));

  return (
    <UnsubscribedViewLayout>
      <Flex
        flexDirection={isTabletAndBelow ? 'column' : 'row'}
        gap={isTabletAndBelow ? '32px' : '64px'}
      >
        <img
          src={SamWave}
          style={{ height: '348px', display: isTabletAndBelow ? 'none' : undefined }}
        />
        <Flex flexDirection="column" maxWidth="500px" gap="24px">
          <Typography variant="displaySmall" textAlign="center">
            Finish setting up your account to unlock the power of {account.userType === 'appraisify' ? 'Appraisify ' : ''}Toolkit ✨
          </Typography>
          <Form referralCode={referralCode} mcKissockOffer={mcKissockOffer} onFinish={onFinish} />
        </Flex>
      </Flex>
    </UnsubscribedViewLayout>
  );
}
